(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("takeExamResource", ["$resource", takeExamResource]);
    function takeExamResource($resource) {
        return $resource("/api/takeExam/:assignmentId/:examAttemptId/:action/:questionNumber/:questionAction", { assignmentId: "@assignmentId", examAttemptId: "@examAttemptId", action: "@action" }, {
            getValidateProctorAndLearnerViewModel: {
                method: "GET",
                params: { action: "validateProctorAndLearnerViewModel" }
            },
            validateLearner: {
                method: "POST",
                params: { action: "validateLearner" }
            },
            validateProctor: {
                method: "POST",
                params: { action: "validateProctor" }
            },
            createOrUpdateActivationExam: {
                method: "POST",
                params: { action: "createOrUpdateActivationExam" }
            },
            checkProctor: {
                method: "POST",
                params: { action: "checkProctor" }
            },
            startExam: {
                method: "POST",
                params: { action: "startExam" }
            },
            getTakeExamSummaryViewModel: {
                method: "GET",
                params: { action: "takeExamSummaryViewModel" }
            },
            getTakeExamResultViewModel: {
                method: "GET",
                params: { action: "takeExamResultViewModel" }
            },
            getQuestionViewModel: {
                method: "GET",
                params: { questionNumber: "@questionNumber" }
            },
            saveMultipleChoice: {
                method: "POST",
                params: { questionNumber: "@questionNumber", questionAction: "saveMultipleChoice" }
            },
            saveLongAnswer: {
                method: "POST",
                params: { questionNumber: "@questionNumber", questionAction: "saveLongAnswer" }
            },
            deleteFileUpload: {
                method: "POST",
                params: { questionNumber: "@questionNumber", questionAction: "deleteFileUpload" }
            }
        });
    }
}());
